"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.OffsetBoxDropCard = void 0;
var _react = _interopRequireWildcard(require("react"));
var _Card = require("../../Card");
var _hooks = require("../../../hooks");
var _Button = require("../../Button");
var _Icon = require("../../Icon");
var _css = require("@emotion/css");
var _OffsetBoxDropCard = _interopRequireDefault(require("./OffsetBoxDropCard.styles"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var OffsetBoxDropCard = /*#__PURE__*/_react.default.forwardRef(function (props, outerRef) {
  var id = props.id,
    children = props.children,
    isAttachedToWindow = props.isAttachedToWindow,
    isWithFilter = props.isWithFilter,
    isFullScreen = props.isFullScreen,
    width = props.width,
    _props$position = props.position,
    position = _props$position === void 0 ? 'bottom' : _props$position,
    onClose = props.onClose,
    onAnimationComplete = props.onAnimationComplete;
  var _useDeviceData = (0, _hooks.useDeviceData)(),
    isMobileView = _useDeviceData.isMobileView;
  var _useState = (0, _react.useState)({}),
    _useState2 = _slicedToArray(_useState, 2),
    containerStyle = _useState2[0],
    setContainerStyle = _useState2[1];
  var styles = (0, _OffsetBoxDropCard.default)();
  var handleClose = function handleClose(event) {
    event === null || event === void 0 ? void 0 : event.stopPropagation();
    if (onClose) {
      onClose();
    }
  };
  (0, _react.useEffect)(function () {
    setTimeout(function () {
      setContainerStyle((0, _css.css)({
        opacity: 1,
        transform: 'scaleY(1)',
        transition: 'transform .35s ease-in-out'
      }));
    }, 50);
  }, []);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
    "data-testid": id ? "dropdown-".concat(id) : null,
    ref: outerRef,
    className: "".concat(styles['cc-OffsetBoxDropCard'], " ").concat(containerStyle),
    style: {
      transformOrigin: isAttachedToWindow || position === 'top' ? 'bottom' : 'top'
    },
    onTransitionEnd: onAnimationComplete,
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Card.Card, {
      width: isAttachedToWindow ? '100vw' : width ? width : 'auto',
      height: isAttachedToWindow && isFullScreen ? '100vh' : 'auto',
      borderRadius: isAttachedToWindow && isFullScreen ? {
        borderStartEndRadius: 0,
        borderStartStartRadius: 0,
        borderEndEndRadius: 0,
        borderEndStartRadius: 0
      } : isAttachedToWindow ? {
        borderStartEndRadius: 19,
        borderStartStartRadius: 19,
        borderEndEndRadius: 0,
        borderEndStartRadius: 0
      } : isWithFilter ? {
        borderStartEndRadius: 19,
        borderStartStartRadius: 19
      } : {},
      isWithShadow: !isMobileView,
      children: [isMobileView && /*#__PURE__*/(0, _jsxRuntime.jsx)(_Card.Card.Section, {
        size: "small",
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          className: styles['cc-OffsetBoxDropCard__close'],
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Button.Button, {
            id: "ccOffsetBoxDropCardClose",
            view: "link",
            color: "basic",
            onClick: handleClose,
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Icon.Icon, {
              name: "Close",
              width: 16,
              height: 16
            })
          })
        })
      }), children]
    })
  });
});
exports.OffsetBoxDropCard = OffsetBoxDropCard;